module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0150.jpg?v=3b1d8cf4";